const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);

// From https://stackoverflow.com/a/6860916
export const getRandomId = () => S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();

export const guuid = getRandomId;
